<div class="container-md p-md-0 mb-5">
  <div *ngIf="is_admin" class="row">
    <div class="col">
      <ts-admin-override-banner
        [prevent_default]="admin_cart_items"
        [admin_override]="shopping_cart && shopping_cart.device_include_admin_options"
        (emit_admin_override)="getAdminOverride($event)"
        (emit_cart_change)="confirmCartChange($event)"
      />
    </div>
  </div>

  <div class="row g-4">
    <div class="col col-12">
      <ts-asset-card
        header="{{ 'selected_line' | translate }}"
        [asset]="shopping_cart && shopping_cart.existing_asset"
        [asset_fields]="['plan', 'plan_features', 'add_on_features']"
      />
    </div>

    <ts-business-plans class="col col-12" />

    <ts-add-on-features
      *ngIf="extras['number_of_plans'] !== 0 && shopping_cart"
      class="col col-12"
    />

    <ts-price-summary
      [reset_cart]="true"
      [hide_one_time_cost]="false"
      [button_status]="!disable_continue_btn"
      [is_display_recurring_cost]="valid_cart"
      [navigate_page]="navigate_page"
      [shopping_cart]="shopping_cart"
      [shopping_items_price]="shopping_items_price"
      [refresh_summary]="refresh_summary.asObservable()"
      (updateCostSummary)="getShoppingCartData($event)"
    />
  </div>
</div>
